<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      :hideOperate="true"
      :rowClassName="rowClassName"
      @size-change="handleSizeChange"
      @on-selection-change="selectionChange"
      @current-change="handleCurrentChange"
      @on-row-click="rowClick"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="search"
          >搜索</el-button
        >
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
      </div>
      <template v-slot:expand>
        <div style="margin-bottom: 20px; vertical: middle">
          <p class="inline-p">操作列表：</p>
          <!-- <el-button style="margin-left:20px;" type="primary" @click="pushList"
            >推送核注</el-button
          >-->
          <el-button style="margin-left: 20px" @click="showModal"
            >新增核注清单</el-button
          >
          <el-button @click="importList">批量导出</el-button>
          <el-button
            style="margin-left: 20px"
            type="primary"
            @click="push"
            :disabled="pushDisabled"
            >推送</el-button
          >
        </div>
        <el-row style="padding-bottom: 20px">
          <el-col :span="20">
            <el-input
              type="textarea"
              :rows="3"
              placeholder="请输入内容"
              v-model="editList"
            ></el-input>
          </el-col>
          <el-col :span="3" :offset="1">
            <el-button @click="createNuclearFunc">完成</el-button>
          </el-col>
        </el-row>
      </template>
    </customize-page>

    <el-dialog
      :visible.sync="visible"
      custom-class="dialog"
      @close="resetForm"
      title="新增核注清单"
    >
      <el-form label-width="80px">
        <el-row>
          <el-col :span="10" :offset="7">
            <el-form-item label="核放单号">
              <el-select v-model="checklistOrderNo" filterable>
                <el-option
                  v-for="(item, index) in checkList"
                  v-bind:key="index"
                  :label="item.checklistOrderNo"
                  :value="item.checklistOrderNo"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template slot="footer">
        <el-button style="margin-right: 30px" @click="resetForm"
          >取消</el-button
        >
        <el-button type="primary" @click="submitForm">确定</el-button>
      </template>
    </el-dialog>

    <el-dialog
      :visible="showDialog"
      custom-class="dialog"
      @close="resetForm"
      title="输入核注清单号，完成核注"
    >
      <el-form label-width="80px">
        <el-row>
          <el-col :span="10" :offset="7">
            <el-form-item label="核注单号">
              <el-input v-model="realEndorsementOrderNo"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template slot="footer">
        <el-button style="margin-right: 30px" @click="resetForm"
          >取消</el-button
        >
        <el-button type="primary" @click="finishList">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";
import { formatDate } from "@/utils/common";

import { mapState, mapActions } from "vuex";

export default {
  components: {
    CustomizePage,
  },
  mixins: [Page],
  created() {
    let initParam = this.$store.state.app.sc["NuclearNoteManage"];
    if (initParam) {
      this.pagination.currentPage = initParam.request.pageIndex;
      this.pagination.pageSize = initParam.request.pageSize;
      this.filterObj = initParam.request.condition;
    }
  },
  mounted() {
    this.fetch();
  },
  data() {
    return {
      visible: false,
      loading: false,
      showDialog: false,
      realEndorsementOrderNo: "",
      dataList: [],
      checkList: [],
      editList: "",
      editRow: {},
      checklistOrderNo: "",
      columns: [
        {
          type: "selection",
          width: 50,
          align: "center",
          fixed: "left",
        },
        {
          title: "编号",
          width: 230,
          key: "endorsementOrderNo",
          align: "center",
        },
        {
          title: "预录入单号",
          width: 230,
          key: "preEndorsementOrderNo",
          align: "center",
        },
        {
          title: "核注清单单号",
          key: "realEndorsementOrderNo",
          width: 230,
          align: "center",
        },
        {
          title: "核放单编号",
          width: 230,
          key: "checklistOrderNo",
          align: "center",
        },
        {
          title: "创建时间",
          width: 200,
          align: "center",
          render: (h, param) => {
            let date = param.row.gmtCreateTime || "";
            return <p>{formatDate(date)}</p>;
          },
        },
        {
          title: "录入时间",
          width: 200,
          key: "gmtCreateTime",
          align: "center",
          render: (h, param) => {
            let date = param.row.gmtCreateTime || "";
            return <p>{formatDate(date)}</p>;
          },
        },
        {
          title: "状态",
          width: 180,
          key: "endorsementStatus",
          align: "center",
          render: (h, param) => {
            if (!param.row && !param.row.endorsementStatus) return;
            return <div>{this.statusDist[param.row.endorsementStatus]}</div>;
          },
        },
        {
          title: "海关回执状态",
          width: 180,
          key: "customsReturnStatus",
          align: "center",
          // render: (h, param) => {
          //   if (!param.row && !param.row.endorsementStatus) return;
          //   return <div>{this.statusDist[param.row.endorsementStatus]}</div>;
          // }
        },
        {
          title: "海关回执信息",
          width: 180,
          key: "customsCheckInfo",
          align: "center",
        },
        // {
        //   title: "总毛重(KG)",
        //   width: 180,
        //   key: "customsCheckInfo",
        //   align: "center"
        // },
        // {
        //   title: "总净重(KG)",
        //   width: 180,
        //   key: "customsCheckInfo",
        //   align: "center"
        // },

        //{row.endorsementStatus !== "FINISH" &&
        // row.endorsementStatus !== "CLOSED" &&
        // row.endorsementStatus !== "CUSTOMS_DECLARING" && (
        //   <a
        //     style={{ color: "#409EFF", padding: "0 10px" }}
        //     onClick={e => {
        //       e.stopPropagation();
        //       this.showFinishDialog(row);
        //     }}
        //   >
        //     完成核注
        //   </a>
        // )}
        {
          title: "操作",
          align: "center",
          fixed: "right",
          render: (h, param) => {
            let row = param.row;
            return (
              <div>
                <a
                  style={{ color: "#409EFF", padding: "0 10px" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    window.open(row.filePath);
                  }}
                >
                  导出
                </a>
                <a
                  style={{ color: "#409EFF", padding: "0 10px" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.showFinishDialog(row);
                  }}
                >
                  完成核注
                </a>
              </div>
            );
          },
        },
      ],

      filterObj: {
        endorsementStatus: "",
        checklistNo: "",
        licensePlate: "",
        expressCode: "",
        checklistStatus: "",
        applyTime: [],
        applyTime2: [],
      },
      currentRow: [],
      statusDist: {
        CREATE: "已创建",
        FINISH: "已完成",
        CUSTOMS_EXCEPTION: "异常",
        CLOSED: "已作废",
        CUSTOMS_DECLARING: "申报中",
      },
      pushDisabled: false,
    };
  },
  computed: {},
  methods: {
    ...mapActions("danding", [
      "addEndorsementOrderByChecklistOrderNo",
      "finishEndorsementOrder",
      "getEndorsementDetail",
      "nuclearPageQuery",
      "fetchNuclearReleaseList",
      "invalidNuclearNote",
      "editEndorsementOrder",
      "batchDownloadEndorsementOrder",
      "declareEndorsementOrder",
    ]),
    push() {
      let endorsementOrderNos = [];
      this.currentRow.map((item) => {
        // if (
        //   item.endorsementStatus === "CREATE" ||
        //   item.endorsementStatus === "CUSTOMS_EXCEPTION"
        // ) {
        endorsementOrderNos.push(item.endorsementOrderNo);
        // }
      });
      if (endorsementOrderNos.length === 0) {
        this.$message.warning("没有可推送数据");
        return;
      }
      this.declareEndorsementOrder({
        request: { endorsementOrderNos },
      }).then((res) => {
        if (res.value) {
          this.fetch();
          this.$message.success("推送成功");
        }
      });
    },
    rowClassName({ row, rowIndex }) {
      if (row.endorsementStatus === "CREATE") {
        return "create-row";
      } else {
        return "";
      }
    },
    fetchCheckList() {
      this.fetchNuclearReleaseList({
        request: {
          checklistStatus: "INPUT_COMPLETED",
          currentPage: 1,
          pageSize: 9999,
        },
      })
        .then((res) => {
          this.checkList = res.customsChecklistOrderItems || [];
        })
        .catch((err) => {});
    },
    showModal() {
      this.visible = true;
      this.fetchCheckList();
    },
    showFinishDialog(row) {
      this.showDialog = true;
      this.editRow = row;
    },
    createNuclearFunc() {
      if (this.editList === "") return;
      if (
        this.editRow.endorsementStatus === "FINISH" ||
        this.editRow.endorsementStatus === "CLOSED"
      ) {
        this.$message.warning("该状态不可修改");
        return;
      }
      let arr = this.editList.split("\n");
      this.loading = true;
      this.editEndorsementOrder({
        request: {
          endorsementOrderNo: this.editRow.endorsementOrderNo,
          mailNos: arr,
        },
      })
        .then((res) => {
          if (res.value) {
            this.$message.success("修改成功");
          } else {
            this.$message.warning("修改异常");
          }
          this.loading = false;
          this.load();
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    rowClick(row, column) {
      if (!row) return;
      this.loading = true;
      this.getEndorsementDetail({
        request: {
          endorsementOrderNo: row.endorsementOrderNo,
        },
      })
        .then((res) => {
          this.loading = false;
          this.editRow = row;
          let mailNos = res.mailNos,
            editList = "";
          if (mailNos && mailNos.length) {
            mailNos.map((item) => {
              editList += item + "\n";
            });
          }
          this.editList = editList;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    resetForm() {
      this.visible = false;
      this.checklistOrderNo = "";
      this.showDialog = false;
      this.realEndorsementOrderNo = "";
    },
    // 新建核放单
    submitForm() {
      this.loading = true;
      this.addEndorsementOrderByChecklistOrderNo({
        request: {
          checklistOrderNo: this.checklistOrderNo,
        },
      })
        .then((res) => {
          if (res.value) {
            this.fetch();
          }
          this.visible = false;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.visible = false;
        });
    },
    // 批量作废
    // invalidList() {
    //   let customsChecklistNos = [];
    //   if (this.currentRow.length === 0) return;
    //   let flag = false;
    //   this.currentRow.map(v => {
    //     if (v.checklistStatus !== "CLOSE") {
    //       customsChecklistNos.push(v.checklistOrderNo);
    //     } else {
    //       flag = true;
    //     }
    //   });
    //   if (flag) {
    //     this.$message.warning("此状态不可以作废");
    //     return;
    //   }
    //   if (customsChecklistNos.length === 0) {
    //     this.$message.warning("请选择尚未作废的数据");
    //     return;
    //   }
    //   this.$confirm("确定要将选中的核放单作废吗？", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消"
    //   })
    //     .then(res => {
    //       this.loading = true;
    //       this.invalidNuclearNote({
    //         request: { customsChecklistNos }
    //       })
    //         .then(res => {
    //           if (res.value) {
    //             this.fetch();
    //             this.$message.success("作废成功");
    //           } else {
    //             this.$message.error("作废失败");
    //           }
    //           this.loading = false;
    //         })
    //         .catch(err => {
    //           this.loading = false;
    //           this.$message.error("作废失败");
    //         });
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     });
    // },
    // 批量推送
    pushList() {},
    // 批量完成
    finishList(row) {
      if (
        this.realEndorsementOrderNo === "" ||
        !this.editRow.endorsementOrderNo
      )
        return;
      this.loading = true;
      this.finishEndorsementOrder({
        request: {
          endorsementOrderNo: this.editRow.endorsementOrderNo,
          realEndorsementOrderNo: this.realEndorsementOrderNo,
        },
      })
        .then((res) => {
          if (res.value) {
            this.$message.success("完成核注清单");
          } else {
            this.$message.success("出现异常，请稍后重试");
          }
          this.loading = false;
          this.fetch();
          this.resetForm();
        })
        .catch((err) => {
          this.loading = false;
          this.resetForm();
        });
    },
    // 分页加载退货订单列表
    fetch() {
      this.loading = true;
      const filterParams = Object.assign({}, this.getFilterParams());
      if (filterParams.applyTime != null) {
        filterParams.gmtCreateTimeStart = new Date(
          filterParams.applyTime[0] + " 00:00:00"
        ).getTime();
        filterParams.gmtCreateTimeEnd = new Date(
          filterParams.applyTime[1] + " 23:59:59"
        ).getTime();
        delete filterParams.applyTime;
      } else {
        delete filterParams.gmtCreateTimeStart;
        delete filterParams.gmtCreateTimeEnd;
      }
      if (filterParams.applyTime2 != null) {
        filterParams.finishTimeStart = new Date(
          filterParams.applyTime2[0] + " 00:00:00"
        ).getTime();
        filterParams.finishTimeEnd = new Date(
          filterParams.applyTime2[1] + " 23:59:59"
        ).getTime();
        delete filterParams.applyTime2;
      } else {
        delete filterParams.finishTimeStart;
        delete filterParams.finishTimeEnd;
      }
      if (filterParams.mailNo) {
        filterParams.mailNos = filterParams.mailNo.split(/[\n]/);
      } else {
        filterParams.mailNos = [];
      }
      delete filterParams.mailNo;
      let searchCondition = {
        request: {
          ...filterParams,
          currentPage: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
        },
      };
      this.nuclearPageQuery(searchCondition)
        .then((res) => {
          this.loading = false;
          this.dataList = res.customsEndorsementOrderItemList || [];
          const pageInfo = res.pageInfo || { totalCount: 0 };
          this.pagination.totalCount = pageInfo.totalCount;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    importList() {
      this.loading = true;
      const filterParams = Object.assign({}, this.getFilterParams());
      if (filterParams.applyTime != null) {
        filterParams.gmtCreateTimeStart = new Date(
          filterParams.applyTime[0] + " 00:00:00"
        ).getTime();
        filterParams.gmtCreateTimeEnd = new Date(
          filterParams.applyTime[1] + " 23:59:59"
        ).getTime();
        delete filterParams.applyTime;
      } else {
        delete filterParams.gmtCreateTimeStart;
        delete filterParams.gmtCreateTimeEnd;
      }
      if (filterParams.applyTime2 != null) {
        filterParams.finishTimeStart = new Date(
          filterParams.applyTime2[0] + " 00:00:00"
        ).getTime();
        filterParams.finishTimeEnd = new Date(
          filterParams.applyTime2[1] + " 23:59:59"
        ).getTime();
        delete filterParams.applyTime2;
      } else {
        delete filterParams.finishTimeStart;
        delete filterParams.finishTimeEnd;
      }
      if (filterParams.mailNo) {
        filterParams.mailNos = filterParams.mailNo.split(/[\n]/);
      } else {
        filterParams.mailNos = [];
      }
      delete filterParams.mailNo;
      this.batchDownloadEndorsementOrder({
        request: filterParams,
      })
        .then((res) => {
          if (res.value) {
            this.$alert("导出成功", "提示", {
              confirmButtonText: "确定",
              callback: (action) => {
                this.$router.push({ name: "download" });
              },
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    selectionChange(rows) {
      this.currentRow = rows;
      // let flag = false;
      // rows.map(item => {
      //   if (
      //     item.endorsementStatus !== "CREATE" &&
      //     item.endorsementStatus !== "CUSTOMS_EXCEPTION"
      //   ) {
      //     flag = true;
      //   }
      // });
      // this.pushDisabled = flag;
    },
    getFormConfig() {
      const type = this.getFormItemType();
      return [
        {
          data: [
            {
              label: "核放单号",
              model: "checklistOrderNo",
              type: type.INPUT,
            },
            {
              label: "核注状态",
              model: "endorsementStatus",
              type: type.SELECT,
              props: {
                data: [
                  { value: "CREATE", label: "已创建" },
                  { value: "FINISH", label: "已完成" },
                  { value: "CUSTOMS_EXCEPTION", label: "异常" },
                  { value: "CLOSED", label: "已作废" },
                  { value: "CUSTOMS_DECLARING", label: "申报中" },
                ],
              },
            },
            {
              label: "录入时间",
              model: "applyTime2",
              type: type.DATE_RANGE,
            },
            {
              label: "创建时间",
              model: "applyTime",
              type: type.DATE_RANGE,
            },
            {
              label: "批量查询运单号",
              model: "mailNo",
              type: type.TEXTAREA,
            },
          ],
        },
      ];
    },
    // 导出数据
    exportData(id) {
      this.loading = true;
      if (typeof id !== "string") return;
      this.exportNuclearReleaseList({
        request: {
          checklistOrderNos: [id],
        },
      }).then((res) => {
        this.loading = false;
        if (res.value) {
          this.$alert("提交成功", "提示", {
            confirmButtonText: "确定",
            callback: (action) => {
              this.$router.push({ name: "download" });
            },
          });
        } else {
          this.$message.error("提交失败");
        }
      });
    },
  },
};
</script>

<style lang="scss">
.row-div {
  padding-right: 30px;
  position: relative;
  button {
    position: absolute;
    right: 60px;
    bottom: 40px;
  }
}
.avatar-uploader {
  display: inline-block;
}
.inline-p {
  display: inline-block;
}
.inline-p span {
  color: #3399ff;
}

.el-dialog .el-dialog__body {
  padding-top: 0;
  padding-bottom: 0;
}
.el-button--text::after {
  background-color: #fff;
}
.dialog .el-form-item__label::before {
  content: "*";
  color: #ff3333;
  margin-right: 4px;
}
.el-dialog__footer {
  text-align: center;
}
.filter_con.filterUp .filter-form {
  height: auto;
  overflow: visible;
}
.el-form-item__content {
  width: 250px;
}
.filter_con .el-input {
  width: 100%;
}
.el-table__body tr.current-row > td {
  background-color: #aad2fa !important;
}
.el-table tr.create-row,
.el-table tr.create-row > td {
  // background-color: #ffe0e0 !important;
}
</style>
